import Modal from './Modal';
import ModalHeader from './ModalHeader';
import ModalFooter from './ModalFooter';
import ModalBody from './ModalBody';
import ModalScrollFooter from './ModalScrollFooter';
import { ModalSize } from './Constants';
export { ModalHeader, ModalBody, ModalFooter, ModalScrollFooter, ModalSize };
export default Modal;
//# sourceMappingURL=index.js.map